export default __webpack_public_path__ + "static/media/background.b19f1cfa.jpg";